import { format, parseISO } from 'date-fns';
import type { DashboardPeriodDto } from '../api/dashboardApi';

export function formatWeekLabel(periods: DashboardPeriodDto[]): string | null {
  if (periods.length === 0) return null;
  if (periods.length === 1) {
    const p = periods[0];
    return `Week ${p.weekNumber}, ${p.year}`;
  }
  const first = periods[0];
  const last = periods[periods.length - 1];
  if (first.year === last.year) {
    return `Weeks ${first.weekNumber}\u2013${last.weekNumber}, ${first.year}`;
  }
  return `Wk ${first.weekNumber} ${first.year} \u2013 Wk ${last.weekNumber} ${last.year}`;
}

export function formatDateRange(periods: DashboardPeriodDto[]): string | null {
  if (periods.length === 0) return null;
  const start = parseISO(periods[0].periodStart);
  const end = parseISO(periods[periods.length - 1].periodEnd);
  return `${format(start, 'd MMM')} \u2013 ${format(end, 'd MMM')}`;
}

export function formatPeriodSubtitle(
  periods: DashboardPeriodDto[]
): string | null {
  const weekLabel = formatWeekLabel(periods);
  const dateRange = formatDateRange(periods);
  if (!weekLabel || !dateRange) return null;
  return `${weekLabel} \u00b7 ${dateRange}`;
}
